import { fetchProfiles, fetchProfileByUserId, searchProfile, fetchProfileById} from "../../api/methods/profile";
import config from "../../config";
import {prepareProfileFilter, getOrderSettings } from "@api/helpers/profileSearch";

export default {
    async fetchProfileById({ commit, dispatch }, id) {
        try {
            const profile = await fetchProfileById(id);
            if (profile) {
                commit('setProfiles', [profile]);
                return profile.userId
            }
        }
        catch (e) {
            dispatch('reportException', e, { root: true });
        }
    },
    async fetchProfiles({commit, dispatch}, userIds) {
        try {
            const profiles = await fetchProfiles(userIds);
            commit('setProfiles', profiles);
        }
        catch (e) {
            dispatch('reportException', e, {root: true});
        }
    },
    async fetchProfile({commit, dispatch}, userId) {
        try {
            const profile = await fetchProfileByUserId(userId);
            if (profile) {
                commit('setProfiles', [profile]);
            }
        }
        catch (e) {
            dispatch('reportException', e, {root: true});
        }
    },
    async searchProfiles({commit, rootGetters, rootState, dispatch}, {page = 1, search = '', groupIds = null}) {
        const searchQuery = prepareProfileFilter({
            searchStr: search,
            additionalFields: [],
            excludingUsers: excludingIds,
            groupFilter: rootGetters['groupFilter'],
            eventId: rootState.events.selected
        });// buildProfileSearch(search);

        let excludingIds = [...rootGetters['chat/rooms/directsRoomsUsers'], ...[rootState.session.userId]];

        if (!rootGetters['events/allowChatWithSpeakers']) {
            excludingIds = [...rootGetters['events/selectedEventSpeakers'], ...excludingIds];
        }
        if (excludingIds) {
            searchQuery['userId'] = {
                "$nin": excludingIds
            }
        }
        if (groupIds && groupIds.length) {
            searchQuery['groupIds'] = {
                "$containsAny": groupIds
            }
        }

        const ignoredUserGroupIds = rootGetters['ignoredUserGroupIds'];

        if (ignoredUserGroupIds) {
            searchQuery['groupIds'] = {
                ...searchQuery['groupIds'],
                $notContainsAny: ignoredUserGroupIds
            }
        }

        let query = {};

        if (Object.keys(searchQuery).length) {
            query = {
                where: searchQuery,
                ...query,
            }
        }

        query['order'] = getOrderSettings(search, "asc", "firstName");
        query['take'] = config.usersPerPage;
        query['skip']= config.usersPerPage * (page - 1);
        let profiles = [];
        try {
            profiles = await searchProfile(query);
            commit('setProfiles', profiles);
        }
        catch (e) {
            dispatch('reportException', e, {root: true});
        }
        return profiles;
    }
}